import { render, staticRenderFns } from "./fieldManage.vue?vue&type=template&id=0828b74e&scoped=true&"
import script from "./fieldManage.vue?vue&type=script&lang=js&"
export * from "./fieldManage.vue?vue&type=script&lang=js&"
import style0 from "./fieldManage.vue?vue&type=style&index=0&id=0828b74e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0828b74e",
  null
  
)

export default component.exports